import PropTypes from 'prop-types'

export const featureType = PropTypes.shape({
    idFeature: PropTypes.number,
    product: PropTypes.number,
    mode: PropTypes.string,
})

export const productType = PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    features: featureType,
})